// extracted by mini-css-extract-plugin
module.exports = {"footer":"StickyButtons_footer__3abba","actions":"StickyButtons_actions__Z6nUO","wrapper":"StickyButtons_wrapper__7xCkf","helptext":"StickyButtons_helptext__3jcNr"};